import { Box } from "@chakra-ui/react";

export const Element = ({ children, maxWidth = undefined }) => {
  return (
    <Box maxWidth={maxWidth ?? "1200px"} mx="auto">
      {children}
    </Box>
  );
};
